import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { withNavigation } from '../../../General/withNavigation';
import {
    postAprobarPublicacionApi,
    postDesaprobarPublicacionApi,
    updatePublicacionEstadoBulkApi
} from '../../../../api/axios'
import { fetchPublicacion, editPublicacion, updateListPublicaciones } from '../../../../actions/publicacionesActions';
import { toast } from 'react-toastify';
import { getIdEstadoPublicacion } from '../../../../helper/publicacionHelper';

// Wrapper para usar hooks en class component
function EstadoWrapper(props) {
  const navigate = useNavigate();
  return <Estado {...props} navigate={navigate} />;
}

class Estado extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            estado: this.props.publicacion.estado,
        };
    }

    handleChange = (event) => {
        event.preventDefault();
        let publicacion = { ...this.props.publicacion };
        publicacion[event.target.name] = event.target.value;
        this.props.editPublicacion(publicacion);
    }

    goToPreviousPath = () => {
        const { pathReturn } = this.props.location.state;
        this.props.navigate(`${pathReturn}`);
    }

    setEstado = (event) => {
        event.preventDefault();
        const { userType } = this.props;
        let publicacion = { ...this.props.publicacion };
        publicacion.estado = event.target.name;

        if ((userType.isAdminMod || userType.isCategory) && publicacion.estado === "activo") {
            const reqAprobar = postAprobarPublicacionApi({ idPublicacion: this.props.publicacion.idPublicacion });
            reqAprobar.then(res => {
                this.props.editPublicacion(publicacion);
                toast.success("Publicación aprobada");
                this.setState({ estado: publicacion.estado })

            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo aprobarse");
            });
        } else {
            if (userType.isAdminMod || userType.isCategory) {
                const reqDesaprobar = postDesaprobarPublicacionApi({ IdPublicacion: this.props.publicacion.idPublicacion });

                reqDesaprobar.then(res => {
                    this.props.editPublicacion(publicacion);
                    toast.success("Publicación desaprobada");
                    this.setState({ estado: publicacion.estado })

                }).catch(err => {
                    (err.response.data.errores)
                        ? err.response.data.errores.forEach(error => toast.error(error))
                        : toast.error("No pudo desaprobarse");
                });
            //} else {
            //    this.props.editPublicacion(publicacion);
            //    //const req = updatePublicacionEstadoVariacionApi(request);
            //    //req.then(res => {
            //    //    this.props.editPublicacion(publicacion);
            //    //    toast.success("Estado modificado");
            //    //    this.setState({ estado: event.target.name })
            //
            //    //}).catch(err => {
            //    //    // (err.response.data.errores)
            //    //    //     ? err.response.data.errores.forEach(error => toast.error(error))
            //    //    //     : toast.error("No pudo editarse");
            //    //}).finally(() => {
            //    //    this.setState({ isClicked: false })
            //    //});
            //
            //}

            //si entro con un seller
            } else {
                this.updateEstado(publicacion);
            }
        }
    }

    updateEstado = async (publicacion) => {
        const idEstado = getIdEstadoPublicacion(publicacion.estado);

        const payload = {
            cambiarEstadoPublicacionesBulks: [{
                idPublicaciones: publicacion.idPublicacion,
                estados: idEstado
            }],
            idUser: this.props.userId
        };

        try {
            await updatePublicacionEstadoBulkApi(payload);
            toast.success("Estado editado");

            //si el estado de la publicacion cambia, llamo al editPublicacion del store y update la lista
            this.props.editPublicacion(publicacion);
            this.props.updateListPublicaciones(this.props.publicaciones, publicacion);
        } catch (err) {
            if (err.response?.data?.errors) {
                err.response.data.errors.forEach(error => toast.error(error.errorMesage));
            } else {
                toast.error("No se pudo editar el estado");
            }
        }
    };

    render() {
        const { isCategory, isAdminMod } = this.props.userType;
        const { publicacion, motivosRevision, inCreate } = this.props;
        const { estado } = this.state;

        const switchClassEstado = () => {
            switch (publicacion.estado) {
                case "activo":
                    return "label-success"
                case "pendiente_activacion":
                    return "label-grey"
                case "pausado":
                    return "label-red"
                case "en_revision":
                    return "label-primary"
                default:
                    return ""
            }
        }

        let motivosDeRevisionOptions = null;
        if (motivosRevision != null) {
            motivosDeRevisionOptions = motivosRevision.map((motivo, index) => {
                return <option key={index} value={motivo.codigo}>{motivo.descripcion}</option>
            });
        }

        let btnAprobarModerador = (isCategory || isAdminMod) && 
            <button
                name="activo"
                onClick={this.setEstado}
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
                disabled={estado === "activo"}
            >
                Aprobar
            </button>;

        let btnPausarModerador = (isCategory || isAdminMod) &&
            <button
                disabled={estado === "pausado" || estado === "en_revision"}
                name="en_revision"
                onClick={this.setEstado}
                className="btn background-rojo-megatone waves-effect btn-sm waves-light m-r-10"
            >
                Pausar
            </button>;

        let btnPublicarSeller = (isCategory || isAdminMod) ? "" :
            <button
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
                disabled={
                    inCreate ||
                    estado !== "pausado"
                }
                name="activo"
                onClick={this.setEstado}
            >
                
                Publicar
            </button>;

        let btnPausarSeller = (isCategory || isAdminMod) ? "" :
            <button
                disabled={estado === "pausado" || inCreate}
                onClick={this.setEstado}
                name="pausado"
                hidden={estado === "en_revision" || estado === "pendiente_activacion"}
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
            >
                Pausar
            </button>;

        if ((estado === "pausado" || inCreate) && (!isCategory && !isAdminMod)) {
            btnPausarSeller = ""
        }

        if ((inCreate
            || estado === "pendiente_activacion"
            || estado === "en_revision"
            || estado === "activo")
            && (!isCategory && !isAdminMod)) {
            btnPublicarSeller = ""
        }

        if ((estado === "activo") && (isCategory || isAdminMod)) {
            btnAprobarModerador = ""
        }

        if ((estado === "pausado" || estado === "en_revision") && (isCategory || isAdminMod)) {
            btnPausarModerador = ""
        }

        let codigoMotRevision = null;
        if (motivosRevision !== undefined) {
            if (motivosRevision.at(-1) !== undefined) {
                codigoMotRevision = motivosRevision.at(-1).codigo;
            }
        }

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-8">

                        <div className="form-group">
                            <div className="d-flex">
                                <div className="mr-auto p-2">
                                    <span className={`label p-10 text-uppercase ${switchClassEstado()}`}>{estado}</span>
                                </div>
                                <div className="p-2 d-none d-lg-block">
                                    {btnPublicarSeller}
                                    {btnPausarSeller}
                                    {btnAprobarModerador}
                                    {btnPausarModerador}
                                </div>
                            </div>
                        </div>

                        <div className="form-group" hidden={publicacion.estado === "activo"}>
                            <label>Motivo</label>
                            <select
                                className=" form-control col-12"
                                disabled={publicacion.estado !== "en_revision" || (!isCategory && !isAdminMod)}
                                value={publicacion.idMotivoRevision}
                                onChange={this.handleChange}
                                id="inlineFormCustomSelect"
                                name="idMotivoRevision"
                            >
                                {motivosDeRevisionOptions}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Operador</label>
                            <input type="text" className="form-control" disabled name="precioLista" />
                        </div>

                        <div className="form-group">
                            <label>Fecha Hora</label>
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                value={publicacion.fechaUltimaModificacion}
                                name="fecha"
                            />
                        </div>

                        <div
                            className="form-group"
                            hidden={publicacion.idMotivoRevision !== codigoMotRevision || publicacion.estado === "activo"}
                        >
                            <label htmlFor="exampleFormControlTextarea1">Comentario</label>
                            <textarea
                                name="observacionesRevision"
                                disabled={!isCategory && !isAdminMod}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                onChange={this.handleChange}
                                rows="3"
                            >
                                {publicacion.observacionesRevision}
                            </textarea>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    varciaciones: state.publicaciones.variacionesPublicacion,
    motivosRevision: state.publicaciones.motivosRevision,
    userId: state.general.userId,
    publicaciones: state.publicaciones.publicaciones,
});

export default withNavigation(connect(mapStateToProps, { fetchPublicacion, editPublicacion, updateListPublicaciones })(EstadoWrapper));